import appConfig from 'application-config';

export const BASE_URL = appConfig.domains.backend.hostname;

export const API_ENDPOINTS = {
	me: '/auth/me',
	checkIP: '/auth/checkIP',
	getSettings: '/settings',
	updateSettings: '/settings/update',

	getCategories: '/categories',
	updateCategory: '/categories/update',
	createCategory: '/categories/create',
	deleteCategory: '/categories/delete',

	getItems: '/items',
	updateItem: '/items/update',
	deleteItem: '/items/delete',

	getPeopleItems: '/people',

	checkSecurity: '/security',

	getCategoryScores: '/scores',

	getSubmissions: '/submission',
	submitSelection: '/submission/selection',
	submitInfo: '/submission/info',
	getAllVotedUsersSize: '/submission/voted-users-count',

	getParticipant: '/participants',
};
